<template>
  <div>
    <v-dialog scrollable v-model="show" @input="close" width="800">
      <v-card>
        <v-card-title>Configurações</v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            hide-default-footer
            :items-per-page="-1"
          >
            <template v-slot:[`item.last_modified`]="{ item }">
              {{ item.last_modified | data }}
            </template>

            <template v-slot:[`item.load`]="{ item }">
              <v-switch
                v-model="item.load"
                inset
                @change="onChangeLoad(item)"
              ></v-switch>
              <!-- <v-chip v-if="item.load" color="success">Sim</v-chip>
            <v-chip v-else color="red" text-color="white">Não</v-chip> -->
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-icon class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <modal-edit-configuracao
      :item="item"
      v-if="showModalEditConfiguracao"
      @close="toggleModalEdit"
      @submit="save($event)"
    />
  </div>
</template>
<script>
import urlApi from "@/routes/urlApi";
import { showError } from "@/global";

export default {
  components: {
    ModalEditConfiguracao: () => import("./ModalEditConfiguracao.vue"),
  },
  data() {
    return {
      showModalEditConfiguracao: false,
      loading: false,
      show: true,
      headers: [
        { text: "File Control", value: "filecontrol_id" },
        { text: "Last File Viewed", value: "last_file_viewed" },
        { text: "Last Modified", value: "last_modified" },
        { text: "Last Batch", value: "last_batch" },
        { text: "Load", value: "load" },
        { text: "Ação", value: "action" },
      ],
      items: [],
      item: {},
    };
  },
  methods: {
    async onChangeLoad(item) {
      try {
        const url = `${urlApi}/postagem/configuracoes/${
          item.filecontrol_id
        }/load`;
        const payload = { load: item.load };
        await this.$http.put(url, payload);
        this.$toasted.global.defaultSuccess();
        this.load();
      } catch (error) {
        showError("Aconteceu Algum Erro");
      }
    },
    close() {
      this.$emit("close");
    },
    editItem(item) {
      this.item = { ...item };
      this.toggleModalEdit();
    },
    toggleModalEdit() {
      this.showModalEditConfiguracao = !this.showModalEditConfiguracao;
    },
    async save(item) {
      item.last_modified = item.last_modified.replace("T", " ");
      try {
        const url = `${urlApi}/postagem/configuracoes/${item.filecontrol_id}`;
        const { data } = await this.$http.put(url, item);
        this.$toasted.global.defaultSuccess();
        this.toggleModalEdit();
        this.load();
      } catch (error) {
        showError("Aconteceu Algum Erro");
      }
    },
    async load() {
      try {
        this.loading = true;
        const url = `${urlApi}/postagem/configuracoes`;
        const { data } = await this.$http.get(url);

        this.items = [...data];
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },

  created() {
    this.load();
  },
};
</script>
